import { useQuery } from '@tanstack/react-query'
import * as endPoints from '@/endpoints'
import useAuth from '@/hooks/useAuth'
import axios from '@/lib/axios'

const useWaterMeters = () => {
    const { activeOrg } = useAuth()
    const activeOrgId = activeOrg?.id

    return useQuery({
        queryKey: ['waterMeters', activeOrgId],
        queryFn: () =>
            axios.get(endPoints.WATER_METERS).then((response) => response.data),
        enabled: Boolean(activeOrgId),
        staleTime: 1000 * 60 * 2,
        placeholderData: () => []
    })
}

export default useWaterMeters
